<template>
  <resolver
    :key="compKey"
    :resolvers="resolvers"
    :route-name="routeName"
  >
    <router-view
      v-slot="{ Component }"
      v-bind="propsAndAttrs"
    >
      <component :is="Component">
        <template
          v-for="name in $slots"
          v-slot:[String(name)]="data"
        >
          <slot
            :name="name"
            v-bind="data"
          />
        </template>
      </component>
    </router-view>
    <template v-slot:failed="{ onRetry }">
      <slot name="failed">
        <tm-error-state
          size="medium"
          @on-retry="onRetry"
        />
      </slot>
    </template>
    <template v-slot:preloader>
      <slot name="preloader">
        <details-page-preload />
      </slot>
    </template>
  </resolver>
</template>

<script lang="ts">
import Resolver from '@/components/resolvers/Resolver.vue'
import { computed, defineComponent, toRef } from '@/composition/vue/compositionApi'
import TmErrorState from '@/components/shared/TmErrorState.vue'
import DetailsPagePreload from '@/components/preloaders/DetailsPagePreload.vue'
import { resolversBaseProps, useResolver } from '@/composition/resolvers'

export default defineComponent({
  components: {
    TmErrorState,
    Resolver,
    DetailsPagePreload,
  },
  inheritAttrs: false,
  props: {
    ...resolversBaseProps,
  },
  setup(props, context) {
    const propsAndAttrs = computed(() => {
      const { routeName, resolvers, ...otherProps } = props

      return { ...context.attrs, ...otherProps }
    })

    const { compKey } = useResolver(toRef(props, 'routeName'))

    return {
      compKey,
      propsAndAttrs,
    }
  },
})
</script>
